import { ReactNode, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddIcon from "../assets/add.svg?react";

import { useAxios } from "../hooks/useAxios";
import { useUser } from "../hooks/useUser";
import { calculateTimeFromMs } from "../utils/general.utils";
import { getAllTracksForUser } from "../utils/track/Track.axios";
import { Track } from "../utils/track/Track.types";

export const TrackOverview = () => {
  const [tracks, setTracks] = useState<Track[]>([]);
  const { axios } = useAxios();
  const { user } = useUser();
  useEffect(() => {
    if (!user || !axios) return;
    getAllTracksForUser(axios, user.id).then(setTracks);
  }, [axios, user]);

  const navigate = useNavigate();

  const trackBoxes: ReactNode = useMemo(() => {
    return tracks
      ?.sort((track) => (track.officialTrack ? -1 : 1))
      .map((track) => (
        <li
          className={`track-overview__track-list__entry ${track.officialTrack ? " official" : ""}`}
          key={track.id}
        >
          <p>{track.name}</p>
          <p>Rundenrekord: {calculateTimeFromMs(track.lapRecord)}</p>
          <p
            className="clickable"
            onClick={() => navigate("/session", { state: { track } })}
          >{`${"Sessions ->"}`}</p>
        </li>
      ));
  }, [navigate, tracks]);

  return (
    <div className="track-overview">
      <AddIcon width={"40px"} onClick={() => navigate("/add")} />
      <ul className="track-overview__track-list">{trackBoxes}</ul>
    </div>
  );
};
